import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { BackgroundImgixWrapper } from '@common/components/BackgroundImgixWrapper';
import { Button } from '@common/components';

import { Link } from 'shared-routing';
import { Routes } from '@common/constants';

import {
  FeaturedLinkInnerWrapper,
  FeaturedLinkWrapper,
  Subtitle,
  Title,
} from './FeaturedLink.styles';

type FeaturedLinkProps = {
  item: {
    title: string;
    url?: string;
    image: {
      url: string;
      externalKey?: string;
    };
    subtitle: string;
    slug?: string;
    htmlTarget?: string;
  };
};

export const FeaturedLink: FC<FeaturedLinkProps> = ({
  item: { title, url, image, subtitle, slug = '', htmlTarget },
}) => {
  const { t } = useTranslations();

  return (
    <BackgroundImgixWrapper src={image && image.url}>
      <FeaturedLinkWrapper background={!!image.url}>
        <FeaturedLinkInnerWrapper>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
          {slug === 'tables' ? (
            <Link route={Routes.TABLES_HOME}>
              <Button isInverted>{t('home.bookTable')}</Button>
            </Link>
          ) : (
            <a href={url} target={htmlTarget}>
              <Button isInverted>{t('home.viewDetails')}</Button>
            </a>
          )}
        </FeaturedLinkInnerWrapper>
      </FeaturedLinkWrapper>
    </BackgroundImgixWrapper>
  );
};
